import React, { Component } from 'react';


class Background extends Component {
  render() {
    return (
      <div className="background">
      </div>
    );
  }

}

export default Background;
